var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VRow',[_c('VCol',{staticClass:"mx-auto",attrs:{"cols":"12","md":"10"}},[_c('VCard',[_c('div',{staticClass:"px-8 py-8",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }